module.exports = __webpack_public_path__ + "img/id-4-300x199.bb641e99.png";